export default __webpack_public_path__ + "static/inschat-home-real-7c2547a3e9f2e365863b91b1ef054e8b.png";